export type TimeoutType = NodeJS.Timeout | number | undefined;

const delay = async (milliseconds: number) => new Promise(resolve => setTimeout(resolve, milliseconds));

export const TIMING_UTILITIES = Object.freeze({
    delay
});